import { createFileRoute } from "@tanstack/react-router";
import SyntheticDrugTreatmentNJ from "@/pages/SyntheticDrugTreatmentNJ";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/synthetic-drug-treatment-nj")({
  head: () => routeHead("/synthetic-drug-treatment-nj"),
  component: SyntheticDrugTreatmentNJ,
});
